import { render, staticRenderFns } from "./domesticConsumer.vue?vue&type=template&id=de2777e4&scoped=true&"
import script from "./domesticConsumer.vue?vue&type=script&lang=js&"
export * from "./domesticConsumer.vue?vue&type=script&lang=js&"
import style0 from "./domesticConsumer.vue?vue&type=style&index=0&id=de2777e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2777e4",
  null
  
)

export default component.exports